import { Currency } from "@/Apollo/schema";
import { LISTING_CURRENCY } from "@/common/static/currency.static";

/**
 * The currency to ask the APIs for, or `undefined` for each listing's own.
 * EUR is sent as absent, as the apps do: listings are in EUR, so asking for
 * it would only store every price a second time under another cache key.
 */
export const toDisplayCurrency = (
  currency: Currency | null | undefined
): Currency | undefined =>
  currency && currency !== LISTING_CURRENCY ? currency : undefined;

/**
 * Adds the display currency to a query's variables. Every converted price
 * field takes it as its own `currency` argument (decision 13, WHO-6100), so
 * Apollo keeps a price per currency. One cache rule of ours is involved: the
 * converted fields key only on the arguments that are set
 * (`lib/apollo/type-policies.ts`), so without a currency they share the
 * plain entry the seller's own fragments read. Without a display currency
 * the variables are left as they are: an omitted argument means the
 * listing's own price.
 */
export const withDisplayCurrency = <TOptions extends { variables?: object }>(
  options: TOptions | undefined,
  currency: Currency | undefined
): TOptions | undefined =>
  currency
    ? ({
        ...options,
        variables: { ...options?.variables, currency },
      } as TOptions)
    : options;
